import React from 'react'
import { useIntl } from 'react-intl'
import AddIcon from '@mui/icons-material/Add'
import { Controller, useFormContext } from 'react-hook-form'
import { Button } from '../../components/Button'
import { LayoutRow } from '../../components/layout'
import EmailAddressFieldItem from './EmailAddressFieldItem'
import FormRow from '../../components/formControls/FormRow'
import { SendDocumentsFormValues } from './types'

export type EmailAddressFieldListProps = {
	emailAddresses: Record<'id', string>[]
	onAddEmail: (email: string) => void
	onRemoveEmail: (index: number) => void
}

const EmailAddressFieldList = ({
	emailAddresses,
	onAddEmail,
	onRemoveEmail,
}: EmailAddressFieldListProps) => {
	const { formatMessage } = useIntl()
	const methods = useFormContext<SendDocumentsFormValues>()

	const {
		control,
		formState: { errors },
	} = methods

	const handleAddEmail = () => {
		onAddEmail('')
	}

	return (
		<>
			{emailAddresses.map((email, index) => (
				<FormRow key={email.id}>
					<Controller
						name={`emailAddresses.${index}`}
						render={({ field: { onChange, value } }) => (
							<EmailAddressFieldItem
								name={`emailAddresses.${index}`}
								label={formatMessage({ id: 'global.email' })}
								data={value}
								onChange={onChange}
								onRemove={() => onRemoveEmail(index)}
								control={control}
								errors={errors}
							/>
						)}
					/>
				</FormRow>
			))}
			<LayoutRow>
				<Button
					text={formatMessage({
						id: 'send_documents_form.add_email_address',
					})}
					onClick={handleAddEmail}
					variant="text"
					startIcon={<AddIcon />}
				/>
			</LayoutRow>
		</>
	)
}

export default EmailAddressFieldList
